import React from 'react'
import { Link } from 'react-router-dom'

interface IProps {
  to: string
  name: string
  description?: string
  imageLink?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const NewWhatsAppBotCard: React.FC<IProps> = ({ to, name, description, imageLink, onClick }) => {
  return (
    <Link
      to={to}
      className='card h-100'
      style={{
        cursor: 'pointer',
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(138, 63, 252, 0.1)',
        borderRadius: '1.25rem',
        boxShadow: '9px 8px 7px rgba(138, 63, 252, 0.1)',
        transition: 'transform 0.2s ease-in-out',
        overflow: 'hidden',
        textDecoration: 'none'
      }}
      // onMouseOver={(e) => (e.currentTarget.style.transform = 'translateY(-5px)')}
      onMouseOut={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
      onClick={onClick}
    >
      {/* Image wrapper ensures consistent sizing */}
      <div
        className='p-3 d-flex justify-content-center align-items-center'
        style={{
          height: '140px',
          backgroundColor: '#fafaff',
          borderBottom: '1px solid rgba(138, 63, 252, 0.05)'
        }}
      >
        <img
          src={imageLink}
          className='card-img-top'
          alt={name}
          style={{
            borderRadius: '0.75rem',
            objectFit: 'contain', // ensures proper fit, no crop/stretch
            width: '100%',
            height: '100%',
            maxWidth: '180px',
            maxHeight: '120px',
            transition: 'transform 0.3s ease'
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        />
      </div>

      <div className='card-body pt-3 px-4 pb-4'>
        <h5
          className='card-title fw-bolder text-dark mb-2'
          style={{ fontSize: '1rem', lineHeight: 1.4 }}
        >
          {name}
        </h5>
        <p
          className='card-text text-muted fs-7'
          style={{
            fontSize: '0.9rem',
            color: '#64748b',
            marginBottom: 0
          }}
        >
          {description}
        </p>
      </div>
    </Link>
  )
}

export default NewWhatsAppBotCard
